__turbopack_context__.v({
  "chip": "AccountOption-module__Ir2MCa__chip",
  "container": "AccountOption-module__Ir2MCa__container",
});
